const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001/api';

class ApiService {
  private getAuthHeaders() {
    const token = localStorage.getItem('auth_token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  }

  async request<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
    const url = `${API_BASE_URL}${endpoint}`;
    const config: RequestInit = {
      headers: {
        'Content-Type': 'application/json',
        ...this.getAuthHeaders(),
        ...options.headers,
      },
      ...options,
    };

    const response = await fetch(url, config);
    
    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: 'Network error' }));
      throw new Error(error.error || `HTTP ${response.status}`);
    }

    return response.json();
  }

  // 认证相关
  async register(data: { username: string; email?: string; password: string }) {
    return this.request<{ user: any; token: string }>('/auth/register', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async login(data: { username: string; password: string }) {
    return this.request<{ user: any; token: string }>('/auth/login', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async guestLogin() {
    return this.request<{ user: any; token: string }>('/auth/guest', {
      method: 'POST',
    });
  }

  // 用户相关
  async getProfile() {
    return this.request<any>('/user/profile');
  }

  async updateSettings(settings: any) {
    return this.request<any>('/user/settings', {
      method: 'PUT',
      body: JSON.stringify(settings),
    });
  }

  async getUserStats() {
    return this.request<any>('/user/stats');
  }

  // 游戏相关
  async saveGameRecord(record: any) {
    return this.request<any>('/game/record', {
      method: 'POST',
      body: JSON.stringify(record),
    });
  }

  async getGameRecords(page = 1, limit = 10) {
    return this.request<any>(`/game/records?page=${page}&limit=${limit}`);
  }

  // 排行榜
  async getLeaderboard(params: { gameMode?: string; difficulty?: string; limit?: number } = {}) {
    const query = new URLSearchParams(params as any).toString();
    return this.request<any>(`/stats/leaderboard?${query}`);
  }
}

export const apiService = new ApiService();
